import { Button } from '@octopus-do/octopus-storybook'
import { connect } from 'react-redux'

const DeleteTeamAvatar = ({ cancelButton, confirmCb, deleteAvatar }) => {
  const handleDeleteAvatar = async () => {
    deleteAvatar()
    confirmCb()
  }

  return (
    <div className="System-dialog__inner">
      <div className="System-dialog__title">Delete avatar</div>

      <div className="System-dialog__description">
        <p>Your avatar will be deleted. Are you sure?</p>
      </div>

      <div className="System-dialog__buttons">
        <div className="System-dialog__buttons-item">
          <Button
            tone="danger"
            size="medium"
            label="Delete"
            onClick={handleDeleteAvatar}
          />
        </div>

        <div className="System-dialog__buttons-item">{cancelButton}</div>
      </div>
    </div>
  )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps)(DeleteTeamAvatar)
